import { site } from "../app/site";

/** "1:14:52" for an hour or more, "32:16" under an hour (the design's timestamps). */
export const clock = (s: number) => {
  const t = Math.max(0, Math.floor(s));
  const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), sec = t % 60;
  return h ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}` : `${m}:${String(sec).padStart(2, "0")}`;
};

/** "Tuesday, September 29, 2026 · 10:00 AM" in the city's time (Chicago's, app/site.ts). */
export const meetingWhen = (iso: string) => {
  const d = new Date(iso);
  const day = d.toLocaleDateString("en-US", { timeZone: site.timeZone, weekday: "long", month: "long", day: "numeric", year: "numeric" });
  const time = d.toLocaleTimeString("en-US", { timeZone: site.timeZone, hour: "numeric", minute: "2-digit" });
  return `${day} · ${time}`;
};

/** "?t=1:14:52" or a clip "?t=1:26:40-1:27:10" (spec 06 card 5) -> start/end seconds. */
export function parseT(value: string | null): { start: number; end: number | null } | null {
  if (!value) return null;
  const sec = (x: string) => x.split(":").reduce((a, v) => a * 60 + Number(v), 0);
  const [a, b] = value.split("-");
  if (!/^\d+(:\d{1,2}){0,2}$/.test(a) || (b && !/^\d+(:\d{1,2}){0,2}$/.test(b))) return null;
  return { start: sec(a), end: b ? sec(b) : null };
}
